angular.module('SpidApp')

.controller('StampChoiceController', ['$uibModalInstance', '$scope', 'CurrencyService', 'Toaster', 'Conversion', 'ConversionRounded',
function ($uibModalInstance, $scope, CurrencyService, Toaster, Conversion, ConversionRounded) {
        $scope.stampChoice = {
            label: $scope.modalStamp.lib_long,
            quantity: 1
            ,
            price: null,
            localPrice: null
            ,
            flightPrice: 0.0,
            serviceTotalPrice: 0.0,
            weight: null,
            basePrice: 0.0
            ,
            valid: false // true if a stamp was found in potentials
            ,
            code_affranchissement: $scope.modalStamp.code_affranchissement,
            code_destination: $scope.modalStamp.code_destination,
            deno_services: '',
            deno_impressions: ''
        }

        $scope.title = $scope.modalStamp.lib_long

        var updateServicesPrice = function () {
            $scope.stampChoice.serviceTotalPrice = $scope.services.reduce(function (memo, service) {
                return memo + (service.isChecked ? service.prix : 0.0)
            }, 0.0)

            $scope.stampChoice.deno_services = _.chain($scope.services).filter(function (service) {
                return service.isChecked
            }).map(function (service) {
                var res = service.code_service_speciaux
                
                if (service.inputPrice) {
                    res = res + ':' + service.inputPrice
                }
                
                return res
            }).value().join(',')

            $scope.stampChoice.deno_impressions = _.chain($scope.services).filter(function (service) {
                return service.isChecked
            }).map(function (service) {
                return service.impression
            }).value().join(',')
        }

        var services = $scope.stampWorkflow.getServices()
        $scope.services = _.map(services, function (service) { // decorate with boolean status
            service.isCheckable = !service.mandatory
            service.isChecked = !!service.mandatory || false
            
            return service
        })
        updateServicesPrice()

        $scope.changeService = function () {
            updateServicesPrice()
        }

        $scope.setLocalPrice = function (value) {
            $scope.stampChoice.localPrice = ConversionRounded.fromRef($scope.agency.currency, Conversion.fromRef($scope.agency.currency, +value))
        }

        $scope.setPrice = function (value) {
            $scope.stampChoice.price = Conversion.toRef($scope.agency.currency, +value)
        }
        
        $scope.setBasePrice = function() {
    		if (!$scope.stampChoice.basePrice || +$scope.stampChoice.basePrice === 0) {
    			$scope.stampChoice.basePrice = 0;
    			$scope.isDisabledQty = false;
    		} else {
    			$scope.isDisabledQty = true;
    			$scope.stampChoice.quantity = 1;
    		}
    		
    		$scope.changeWeight(); 
    		
    		//$scope.stampChoice.localPrice = +($scope.stampChoice.localPrice - $scope.stampChoice.basePrice).toFixed(2);
    		//$scope.setPrice($scope.stampChoice.localPrice);
    		//$scope.stampChoice.price = +($scope.stampChoice.price - $scope.stampChoice.basePrice || 0).toFixed(2);
    		//$scope.setLocalPrice($scope.stampChoice.price);
    	}

        $scope.changeWeight = function () {
            var weight = +$scope.stampChoice.weight

            if (!weight) {
                return
            }

            try {
                $scope.stampWorkflow.filterByPoids(weight)
                $scope.stampChoice.weight = weight

                var price = $scope.stampWorkflow.getPrix()

                $scope.stampChoice.price = +(price - $scope.stampChoice.basePrice || 0).toFixed(2);
    			$scope.setLocalPrice($scope.stampChoice.price);
                $scope.stampChoice.flightPrice = $scope.stampWorkflow.getComplementAerien()
            } catch (e) {
                console.error(e)

                $scope.stampChoice.price = null
                $scope.stampChoice.localPrice = null
                $scope.stampChoice.flightPrice = 0.0

                Toaster.danger("Le poids de ce plis/colis n'est pas compatible avec le produit d'affranchissement <b>" + $scope.stampChoice.label + "</b>")
            }
        }

        $scope.modalLoaded = true;

        $scope.ok = function () {
            if (!$scope.stampChoiceForm.$valid) {
                return
            }

            var totalPrice = $scope.stampChoice.price + $scope.stampChoice.flightPrice + $scope.stampChoice.serviceTotalPrice

            $scope.stampChoice.price 	  = +totalPrice
            $scope.stampChoice.localPrice = ConversionRounded.fromRef($scope.agency.currency, Conversion.fromRef($scope.agency.currency, totalPrice))

            $uibModalInstance.close($scope.stampChoice)
        }
        
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }

        $scope.getWeightFromScale = function () {
            Scale.getWeight().then(function (data) {
                $scope.stampChoice.weight = data.value.Valeur
                $scope.changeWeight()
            }, function () {
                Toaster.danger('Impossible de récupérer le poids')
            })
        }
        
        $scope.getWeightFromScale()
        
        $scope.changeServiceInput = function (service, input) {
            service.selectedTranche = _.chain(service.tranches).find(function (t) {
                return t.tranche_inferieure <= input && input <= t.tranche_superieure
            }).value()
            
            service.prix = null
            if (service.selectedTranche) {
                service.prix = service.selectedTranche.prix
            }
            
            service.isChecked = false
            
            updateServicesPrice()
        }
}])